import {ChangeDetectionStrategy, Component, input, OnDestroy, OnInit, output} from '@angular/core';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {debounceTime, Subject, takeUntil} from 'rxjs';
import {MatIconModule} from '@angular/material/icon';
import {NgClass} from '@angular/common';

import {OphButtonModule} from '../oph-button/oph-button.module';
import {OphIconModule} from '../oph-icon/oph-icon.module';

@Component({
  selector: 'oph-page-header',
  standalone: true,
  imports: [OphButtonModule, MatIconModule, OphIconModule, FormsModule, ReactiveFormsModule, NgClass],
  templateUrl: './oph-page-header.component.html',
  styleUrl: './oph-page-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OphPageHeaderComponent implements OnInit, OnDestroy {
  title = input<string>('Section title');
  description = input<string>('Section description');
  primaryActionButtonChange = output<boolean>();
  primaryActionButtonText = input<string>('Primary Action');
  primaryActionButtonIcon = input<string>('add');

  searchInputControl = new FormControl<string>('');
  searchInputPlaceholder = input<string>('Search');
  searchInputChange = output<string>();
  searchInputDebounceTime = input<number>(300);

  unsubscribe$ = new Subject<void>();

  ngOnInit(): void {
    this.onSearchInputControlChanges();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onSearchInputControlChanges(): void {
    this.searchInputControl.valueChanges
      .pipe(takeUntil(this.unsubscribe$), debounceTime(this.searchInputDebounceTime()))
      .subscribe(value => {
        this.searchInputChange.emit(value);
      });
  }

  onPrimaryActionButtonClick(): void {
    this.primaryActionButtonChange.emit(true);
  }
}
